import { clone, onError } from '../../common/common';
import { getLabels } from './common';
import ChatApi from '../../design/api/chat-api';

// ------------------------------------
// Constants
// ------------------------------------
export const CHAT_APPEND_MESSAGES = 'CHAT_APPEND_MESSAGES';
export const CHAT_PREPEND_MESSAGES = 'CHAT_PREPEND_MESSAGES';
export const CHAT_READ_MESSAGES = 'CHAT_READ_MESSAGES';
export const CHAT_LOAD_LAST_MESSAGES = 'CHAT_LOAD_LAST_MESSAGES';
export const CHAT_LOAD_LAST_MESSAGES_ERROR = 'CHAT_LOAD_LAST_MESSAGES_ERROR';
export const CHAT_SEARCH_VALUE = 'CHAT_SEARCH_VALUE';
export const CHAT_SCROLL_LAST_MESSAGES = 'CHAT_SCROLL_LAST_MESSAGES';
export const GET_CHAT_MEDIA = 'GET_CHAT_MEDIA';
export const GET_All_CHAT_MEDIA = 'GET_All_CHAT_MEDIA';
export const PREV_CHAT_ITEMS_QUERY = 'PREV_CHAT_ITEMS_QUERY';

// ------------------------------------
// Actions
// ------------------------------------

export const loadMessages = (chatId, timestamp) => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      ChatApi.getMessagesFrom(
        chatId,
        timestamp,
        data => {
          const { messages } = data;
          dispatch({ type: CHAT_APPEND_MESSAGES, payload: { messages } });
        },
        onError,
      );
    });
  };
};

export const loadChatMedia = (projectId, type, timestamp) => {
  if (type === 'all') {
    return loadAllChatMedia({ projectId });
  }

  return (dispatch, getState) => {
    return new Promise(resolve => {
      ChatApi.getProjectMedia(
        projectId,
        type,
        timestamp,
        ({ data }) => {
          dispatch({ type: GET_CHAT_MEDIA, payload: { mediaFilesList: data } });
          resolve(data);
        },
        onError,
      );
    });
  };
};

export const callprevQueryChat = props => {
  const prevQueriesMapping = { loadAllChatMedia, loadPrevPage, loadLastMessages };

  return (dispatch, getState) => {
    const {
      chat: { prevChatItemsQuery },
    } = getState();
    if (!prevChatItemsQuery) return;

    const queryParams = { ...prevChatItemsQuery.props };
    let queryFunction = prevQueriesMapping[prevChatItemsQuery.name];
    if (queryFunction === loadPrevPage && (props && prevChatItemsQuery && prevChatItemsQuery.props && props.s != prevChatItemsQuery.props.s)) {
      queryFunction = loadLastMessages;
    }
    queryFunction(queryParams)(dispatch, getState);
  };
};

export const loadAllChatMedia = ({ projectId, ...rest }) => {
  return (dispatch, getState) => {
    const currentChatSearchValue = getState().chat.currentChatSearchValue;

    return new Promise(resolve => {
      ChatApi.getAllDocsMedia({ projectId, ...rest, s: currentChatSearchValue }, ({ data }) => {
        dispatch({ type: GET_All_CHAT_MEDIA, payload: { mediaFilesList: data } });
        dispatch({
          type: PREV_CHAT_ITEMS_QUERY,
          payload: { prevChatItemsQuery: { name: 'loadAllChatMedia', props: { projectId } } },
        });
        resolve(data);
      });
    });
  };
};

export const onNewMessages = (messages, scrollToBottomEffect) => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      dispatch({ type: CHAT_APPEND_MESSAGES, payload: { messages, scrollToBottomEffect } });
    });
  };
};

export const loadPrevPage = ({ chatId, timestamp, s, ...rest }) => {
  return (dispatch, getState) => {
    const currentChatSearchValue = getState().chat.currentChatSearchValue;
    return new Promise(resolve => {
      if (timestamp) {
        ChatApi.getMessagesTo(
          { chatId, timestamp, ...rest, s: currentChatSearchValue },
          response => {
            const { data: messages } = response;
            dispatch({ type: CHAT_PREPEND_MESSAGES, payload: { messages } });
            const newTimestamp =
              messages && messages.size > 0 ? messages[messages.length - 1].timestamp : timestamp;
            dispatch({
              type: PREV_CHAT_ITEMS_QUERY,
              payload: {
                prevChatItemsQuery: {
                  name: 'loadPrevPage',
                  props: { chatId, s, timestamp: newTimestamp },
                },
              },
            });
          },
          onError,
        );
      }
    });
  };
};

export const changeSearchValue = v => dispatch => {
  dispatch({ type: CHAT_SEARCH_VALUE, payload: { currentChatSearchValue: v } });
};

export const loadLastMessages = ({ chatId, timestamp, s, ...rest }) => {
  return (dispatch, getState) => {
    const currentChatSearchValue = getState().chat.currentChatSearchValue;

    return new Promise(resolve => {
      dispatch({ type: CHAT_LOAD_LAST_MESSAGES_ERROR, payload: { error: false } });
      ChatApi.getMessagesTo(
        { chatId, timestamp, ...rest, s: currentChatSearchValue },
        messages => {
          dispatch({ type: CHAT_LOAD_LAST_MESSAGES, payload: { messages } });
          dispatch({
            type: PREV_CHAT_ITEMS_QUERY,
            payload: {
              prevChatItemsQuery: { name: 'loadLastMessages', props: { chatId, timestamp, s } },
            },
          });
        },
        () => dispatch({ type: CHAT_LOAD_LAST_MESSAGES_ERROR, payload: { error: true } }),
      );
    });
  };
};

export const readMessages = (chatId, messageIds) => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      dispatch({ type: CHAT_READ_MESSAGES, payload: { ids: messageIds, chatId } });
      ChatApi.readMessages(chatId, messageIds, () => {}, onError);
    });
  };
};

export const toggleScrollToBottomEffect = scrollToBottomEffect => {
  return (dispatch, getState) => {
    dispatch({ type: CHAT_SCROLL_LAST_MESSAGES, payload: { scrollToBottomEffect } });
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processAppend = (state, action) => {
  const { messages: appendMessages, scrollToBottomEffect } = action.payload;
  const messages = [...state.messages];
  if (appendMessages.length > 0) {
    appendMessages.forEach(m => {
      const index = messages.findIndex(i => m.id === i.id);
      if (index !== -1) {
        messages.splice(index, 1, m);
      } else {
        messages.push(m);
      }
    });

    return {
      ...state,
      messages,
      labels: getLabels(messages),
      timestamp: messages[messages.length - 1].timestamp + 1,
      messagesInitialized: true,
      scrollToBottomEffect,
    };
  }
  return { ...state, messagesInitialized: true, messagesInitializationError: false };
};

const processPrepend = (state, action) => {
  const { messages: messagesToPrepend } = action.payload;
  if (messagesToPrepend.length > 0) {
    const messages = [...state.messages];
    messagesToPrepend.reverse().forEach(m => {
      const index = messages.findIndex(i => m.id === i.id);
      if (index !== -1) {
        messages.splice(index, 1, m);
      } else {
        messages.unshift(m);
      }
    });
    return {
      ...state,
      messages,
      messagesInitialized: true,
      messagesInitializationError: false,
      labels: getLabels(messages),
    };
  }
  return { ...state, messagesInitialized: true, messagesInitializationError: false };
};

const processLoadLast = (state, action) => {
  const messages = action.payload.messages.data;
  // console.log(messages);
  if (messages.length > 0) {
    return {
      ...state,
      messages,
      labels: getLabels(messages),
      messagesInitialized: true,
      messagesInitializationError: false,
      scrollToBottomEffect: true,
    };
  }
  return { ...state, messages: [], messagesInitialized: true, messagesInitializationError: false };
};

const processLoadLastError = (state, action) => {
  const { error } = action.payload;
  return { ...state, messages: [], messagesInitialized: false, messagesInitializationError: error };
};

const processScrollLast = (state, action) => {
  const { scrollToBottomEffect } = action.payload;
  return { ...state, scrollToBottomEffect };
};

const processReadMessages = (state, action) => {
  const { ids: messageIdsToUpdate, chatId } = action.payload;
  const { messages: prevMessages, chats: prevChats } = state;
  const messages = [];

  const chats = [...prevChats];
  const chat = chats.find(chatItr => chatItr.id === chatId);
  let { new_messages_count: newMessagesCount } = chat;
  prevMessages.forEach(message => {
    const messageToUpdate = messageIdsToUpdate.includes(message.id.toString());
    if (messageToUpdate && !message.seen) {
      messages.push({ ...message, seen: Date.now() });
      newMessagesCount = Math.max(newMessagesCount - 1, 0);
    } else {
      messages.push(message);
    }
  });
  chat.new_messages_count = newMessagesCount;
  return { ...state, chats, messages };
};

const processMediaChat = (state, action) => ({ ...state, ...action.payload });

const processAllChatMedia = (state, action) => ({ ...state, ...action.payload });

const proccesLastQuery = (state, action) => ({ ...state, ...action.payload });

const proccesChatSearchChange = (state, action) => ({ ...state, ...action.payload });

export const LOAD_MESSAGES_ACTION_HANDLERS = {
  [CHAT_APPEND_MESSAGES]: processAppend,
  [CHAT_PREPEND_MESSAGES]: processPrepend,
  [CHAT_LOAD_LAST_MESSAGES]: processLoadLast,
  [CHAT_SCROLL_LAST_MESSAGES]: processScrollLast,
  [CHAT_LOAD_LAST_MESSAGES_ERROR]: processLoadLastError,
  [CHAT_READ_MESSAGES]: processReadMessages,
  [GET_CHAT_MEDIA]: processMediaChat,
  [GET_All_CHAT_MEDIA]: processAllChatMedia,
  [PREV_CHAT_ITEMS_QUERY]: proccesLastQuery,
  [CHAT_SEARCH_VALUE]: proccesChatSearchChange,
};



// WEBPACK FOOTER //
// ./app/javascript/chat/modules/load-messages.js